const axios = require('axios');
const he = require('he');
const _ = require('lodash');

/*
 * Code
 */
export function getBadges() {
    const entryPoint = '/wp-json/wp/v2/badge';
    return axios
        .get(entryPoint)
        .then(res => res.data)
        .then(res => res.map(b => ({
            id: b.id,
            name: b.title.rendered,
            description: he.decode(b.content.rendered.replace(/<[^>]+>/g, '')),
            rules: b['rules-meta'].rules,
            type: b['rules-meta'].type.toLowerCase(),
            icon: b['rules-meta'].icon
        }))).then(badges => ({ badges }));
}

function allWithTag(rule, quiz) {
    if (!rule.tag)
        return false;

    let cnt = 0;

    _.forEach(quiz.answers, (value, key) => {
        if (_.includes(value.tags, rule.tag)) {
            cnt += 1;
            if (value.answer != value.correct) {
                return false;
            }
        }
    });

    return cnt > 0;
}

function timeBelow(rule, quiz) {
    // console.log("timeBelow:", quiz.startDate, quiz.endDate, rule.time);

    if (rule.time && (quiz.endDate - quiz.startDate) <= rule.time)
        return true;

    return false;
}

function pointsAbove(rule, quiz) {
    if (rule.points && quiz.points >= rule.points)
        return true;

    return false;
}

function totalPointsAbove(rule, allQuizResults) {
    if (rule.points && allQuizResults.score >= rule.points)
        return true;

    return false;
}

function totalPointsPerTag(rule, allQuizResults) {
    if (rule.props && rule.props.points && rule.props.tag && allQuizResults.tags && allQuizResults.tags[rule.props.tag] >= rule.props.points)
        return true;

    return false;
}

const RULES = {
    quiz: {
        'tags': allWithTag,
        'time': timeBelow,
        'points': pointsAbove
    },
    all: {
        'points': totalPointsAbove,
        'pointsForTag': totalPointsPerTag
    }
};

function computePerQuizBadge(badge, quiz) {
    const res = badge.rules.map((rule) => RULES.quiz[rule.type] && RULES.quiz[rule.type](rule, quiz));
    return _.every(res) && badge.id;
}

function computeBadge(badge, allQuizResults) {
    const res = badge.rules.map((rule) => RULES.all[rule.type] && RULES.all[rule.type](rule, allQuizResults));
    return _.every(res) && badge.id;
}

export function recalculateBadges(quiz, allQuizResults) {
    return getBadges()
        .then(badges => badges.badges)
        .then(badges => badges.map(badge => badge.type == 'quiz' ? computePerQuizBadge(badge, quiz) : computeBadge(badge, allQuizResults)))
        .then(badges => badges.filter(val => val))
        .then(res => { /*console.log("Badges:", res);*/ return res; })
        .catch(err => console.error(err));
}
